export default "/images/insta.svg?a15c7b7b4439e91c96a7c270be0ded64";